import {createContext} from 'react';
import type {FlowPreview} from 'crqlar-react-common/dist/models/automation/flowPreview.model';

export interface FlowPreviewCards {
    preview?: FlowPreview;
    /** The first answer is on its way. */
    loading: boolean;
    /** A newer answer is on its way; the numbers shown are the previous ones. */
    refreshing: boolean;
    onOpen: (nodeId: string) => void;
}

/** Null outside the editor (the template preview): cards draw without numbers. */
export const FlowPreviewContext = createContext<FlowPreviewCards | null>(null);
